import type { FC } from 'react';
import clsx from 'clsx';
import { Picture, Input, Select } from '@ui';
import {
  orderRegisterLocation,
  orderRegisterHover,
  orderRegisterUnchecked,
  orderRegisterChecked
} from '@images';
import type { PrepareAllCommentsOptionsReturnType } from '@utils/orderUtils/prepareAllCommentsOptions';
import AddressCheckbox from './AddressCheckbox';

type Checkboxes = NonNullable<
  PrepareAllCommentsOptionsReturnType['checkboxes']
>;
type Selects = NonNullable<PrepareAllCommentsOptionsReturnType['selects']>;
type OrderHome = NonNullable<PrepareAllCommentsOptionsReturnType['orderHome']>;

interface AddressOptionsProps {
  comment: string;
  onCommentChange: (value: string) => void;
  isShowComment: boolean;
  onToggleComment: () => void;
  checkboxes: Checkboxes;
  selects: Selects;
  isMainAddress: boolean;
  orderHome: OrderHome | null | undefined;
  onSelectMainAddress: () => void;
  changeNewParams: (
    type: string,
    value: boolean | number | string,
    index?: number
  ) => void;
}

const AddressOptions: FC<AddressOptionsProps> = ({
  comment,
  onCommentChange,
  isShowComment,
  onToggleComment,
  checkboxes,
  selects,
  isMainAddress,
  orderHome,
  onSelectMainAddress,
  changeNewParams
}) => (
  <div className='user-info'>
    <div className='address-info'>
      <div className='flex items-center justify-between'>
        <div className='comment-label' onClick={onToggleComment}>
          <div className='desctop-comment-label'>
            <Picture
              icon={orderRegisterLocation}
              height='24'
              pictureClassName='sm:hidden'
              className='picture'
            />
            Как курьеру проехать к дому
          </div>
          <div className='mobile-comment-label'>
            <Picture
              icon={orderRegisterLocation}
              height='24'
              className='picture'
            />
            Как проехать
          </div>
        </div>
        <OrderHomeToggle
          orderHome={orderHome}
          changeNewParams={changeNewParams}
        />
      </div>

      <Input
        classNameParent={clsx(
          'order-page-input text-area',
          !isShowComment && ' is-hidden-field'
        )}
        classNameInput='custom-input text-area'
        placeHolder='Другие комментарии'
        value={comment}
        field='comment'
        inputType='text'
        onInputBlur={next => {
          onCommentChange(next);
        }}
        updatedBackgroung
      />

      <div className='checkboxes'>
        {checkboxes?.map((item, index) => {
          if (item.attachment !== 'address') return null;
          return (
            <AddressCheckbox
              key={item.id}
              checked={!!item.value}
              onChange={() => {
                changeNewParams('checkboxes', !item.value, index);
              }}
              label={item.title}
              iconHover={
                item.value ? orderRegisterChecked.x3 : orderRegisterHover.x3
              }
              description={item.description}
            />
          );
        })}
        <AddressCheckbox
          checked={isMainAddress}
          onChange={onSelectMainAddress}
          label='Сделать адрес основным'
        />
      </div>
    </div>

    {selects?.map((item, index) => {
      if (item.attachment !== 'address') return null;
      return (
        <div className='order-page-input' key={item.id}>
          <Select
            style={{ fontSize: '14px' }}
            className='order-page-custom-select'
            list={item.options?.map(opt => ({
              value: opt.id,
              label: opt.title
            }))}
            activeValue={item.value || -1}
            passiveTitle={item.title}
            callback={(_field: string, value: number) => {
              changeNewParams('selects', value || -1, index);
            }}
            field='profile_id'
          />
        </div>
      );
    })}
  </div>
);

interface OrderHomeToggleProps {
  orderHome: OrderHome | null | undefined;
  changeNewParams: (
    type: string,
    value: boolean | number | string,
    index?: number
  ) => void;
}

export const OrderHomeToggle: FC<OrderHomeToggleProps> = ({
  orderHome,
  changeNewParams
}) => {
  if (!orderHome) return <div />;
  return (
    <div
      className='home'
      onClick={() => {
        changeNewParams('orderHome', !orderHome?.value);
      }}
    >
      <Picture
        icon={
          orderHome?.value ? orderRegisterChecked.x3 : orderRegisterUnchecked.x3
        }
        iconHover={orderRegisterHover.x3}
        height='20'
        className={
          orderHome?.value ? 'icon checked-icon' : 'icon unchecked-icon'
        }
      />
      <span>Частный дом</span>
    </div>
  );
};

export default AddressOptions;
